import { IntlTFunc } from 'next-intl';

import { ProductFragment, SimpleProductFragment } from '@/fo/api/magento';

import { MappedProduct, GroupedProduct, ProductsMindbox } from '../types';

import { utilMapSimpleProductData } from './utilMapSimpleProductData';

export const utilMapGroupedProductData = (
  product: ProductFragment,
  t: IntlTFunc,
  mindboxProducts?: ProductsMindbox
): MappedProduct => {
  const productData = product as GroupedProduct;

  const {
    sku,
    mindboxId,
    link,
    specialPrice,
    basePrice,
    finalPrice,
    labels,
    baseImage,
    thumbnail,
    structureImage,
    mediaGallery,
    stockStatus,
    characteristics,
    brand,
    catalogBrandUrl,
    series,
    video,
    effects,
    benefits,

    labelsBonus,
    bonusPoints,
    bonusPointsMax,
    earnedBonusPoints,

    name,
    subtitle,
    shortDescription,
    firstLevelCategory,
    lastLevelCategory,
    breadcrumbs,
    labelsBrand,
    rating,
    reviewCount,
    bestRating,
    worstRating,
    purpose,
    stockQuantity,

    description_html,
    activeComponents,
    composition,
    usageInstructions,
    visibility,

    productGroup,
    brandCode,
    videoExpertOpinionPreview,
    videoExpertOpinionVideo,
    videoExpertOpinionExpertUrlKey
  } = utilMapSimpleProductData(productData, t, mindboxProducts);

  const items =
    'items' in productData && productData.items
      ? (productData.items
          .map((item) =>
            item?.product
              ? utilMapSimpleProductData(
                  item.product as SimpleProductFragment,
                  t,
                  mindboxProducts
                )
              : undefined
          )
          .filter(Boolean) as MappedProduct[])
      : [];

  return {
    sku,
    mindboxId,
    name,
    subtitle,
    brand,
    brandCode,
    catalogBrandUrl,
    series,
    effects,
    benefits,
    link,
    shortDescription,
    specialPrice,
    basePrice,
    finalPrice,
    firstLevelCategory,
    lastLevelCategory,
    breadcrumbs,
    labelsBrand,
    labelsBonus,
    labels,
    baseImage,
    thumbnail,
    structureImage,
    mediaGallery,
    rating,
    reviewCount,
    bestRating,
    worstRating,
    stockStatus,
    stockQuantity,
    video,
    bonusPoints,
    bonusPointsMax,
    earnedBonusPoints,

    items,
    purpose,

    groupType:
      'groupType' in productData ? (productData.groupType as number) : null,

    description_html,
    characteristics,
    activeComponents,
    composition,
    usageInstructions,

    productGroup,

    visibility,
    videoExpertOpinionPreview,
    videoExpertOpinionVideo,
    videoExpertOpinionExpertUrlKey
  };
};
